import { useRouter } from 'next/router'
import { useAuthContext } from 'user-auth'

const useIsMyProfile = () => {
  const router = useRouter()

  const { user } = useAuthContext()

  return !!router.query.userId && !!user && user.id === router.query.userId
}

export { useIsMyProfile }
